import { MonacoEditorConfig } from './monaco-editor.config';

declare const monaco: any;

export const MONACO_EDITOR_DEFAULT_CONFIG: MonacoEditorConfig = {
  baseUrl: 'assets',
  defaultOptions: {
    scrollBeyondLastLine: false,
    minimap: { enabled: false }
  },
  onMonacoLoad: () => {
    // Ensure monaco object is available
    if (typeof monaco === 'undefined') {
      console.error('Monaco editor is not available. Skipping custom configuration.');
      return;
    }

    // --- Global JSON Language Configuration ---
    if (monaco.languages.json && monaco.languages.json.jsonDefaults) {
      monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: false, // Turn off default validation
        allowComments: false,
        schemas: [],
        enableSchemaRequest: false,
        schemaRequest: 'ignore',
        trailingCommas: 'ignore',
        comments: 'ignore'
      });

      monaco.languages.json.jsonDefaults.setModeConfiguration({
        documentFormatting: true,
        documentRangeFormatting: true,
        completion: true,
        hover: true,
        documentSymbols: true,
        tokens: true,
        colors: true,
        foldingRanges: true,
        diagnostics: false,
        documentHighlights: true,
        documentLinks: true,
        codeActions: true,
        rename: true,
        signatureHelp: true,
        onEnter: true,
        definition: true,
        typeDefinition: true,
        references: true,
        implementation: true,
        codeLens: true,
        inlayHints: true,
        semanticTokens: true,
        callHierarchy: true,
        linkedEditingRange: true
      });
    }

    // --- Global CSS Language Configuration ---
    if (monaco.languages.css && monaco.languages.css.cssDefaults) {
      monaco.languages.css.cssDefaults.setDiagnosticsOptions({
        validate: false, // Turn off default validation
        lint: { // Disable all linting rules
          unknownAtRules: 'ignore',
          unknownVendorSpecificProperties: 'ignore',
          unknownProperties: 'ignore',
          unknownUnits: 'ignore',
          duplicateProperties: 'ignore',
          emptyRules: 'ignore',
          importStatement: 'ignore',
          boxModel: 'ignore',
          compatibleVendorPrefixes: 'ignore',
          vendorPrefix: 'ignore',
          fallbackColor: 'ignore',
          hexColorLength: 'ignore',
          argumentsInColorFunction: 'ignore',
          ieHack: 'ignore',
          unknownTags: 'ignore',
          zeroUnits: 'ignore',
          fontFaceProperties: 'ignore',
          hexColors: 'ignore',
          propertyIgnoredDueToDisplay: 'ignore',
          important: 'ignore',
          float: 'ignore',
          idSelector: 'ignore'
        }
      });

      monaco.languages.css.cssDefaults.setModeConfiguration({
        documentFormatting: true,
        documentRangeFormatting: true,
        completion: true,
        hover: true,
        documentSymbols: true,
        tokens: true,
        colors: true,
        foldingRanges: true,
        diagnostics: false, // Turn off diagnostics in the mode config
        documentHighlights: true,
        documentLinks: true,
        codeActions: true,
        rename: true,
        signatureHelp: true,
        onEnter: true,
        definition: true,
        typeDefinition: true,
        references: true,
        implementation: true,
        codeLens: true,
        inlayHints: true,
        semanticTokens: true,
        callHierarchy: true,
        linkedEditingRange: true
      });
    }
  }
};
